import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { SearchTransactionHistoryRequestModel } from '../../model/searchTransactionHistoryRequestModel';
import { SearchTransactionHistoryResponseModel } from '../../model/searchTransactionHistoryResponseModel';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { TransactionsService } from '../transactions.service';
import { SpinnerService } from '../../shared/spinner/spinner.service';
import { Router } from '@angular/router';
import { CurrentPageWatcherService } from '../../shared/utils/CurrentPageWatcher';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MessageModel } from '../../model/models';
import * as $ from 'jquery';

@Component({
  selector: 'app-transaction-history-individual-search',
  templateUrl: './transaction-history-individual-search.component.html',
  styleUrls: ['./transaction-history-individual-search.component.css']
})
export class TransactionHistoryIndividualSearchComponent implements OnInit {
  title = "View My Transaction History";
  loading: boolean = false;

  transactionIndividualHistoryModelSubscription: Subscription;
  transactionHistoryRequestModel = new SearchTransactionHistoryRequestModel();
  individualTransactionHistory = new SearchTransactionHistoryResponseModel();

  startDate: Object = null;
  endDate: Object = null;

  userMessages: Array<MessageModel> = [];
  
  public myForm: FormGroup;

  public mmyyyyDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    editableDateField: true,
    openSelectorOnInputClick: true

  }
  constructor(private currentPageWatcher: CurrentPageWatcherService, private transactionsService: TransactionsService, private currentPageWatcherService: CurrentPageWatcherService,
    private spinner: SpinnerService, private router: Router,
    private formBuilder: FormBuilder) {

    this.myForm = this.formBuilder.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
    });

    this.transactionIndividualHistoryModelSubscription = this.transactionsService.notifyTransactionIndividualHistoryModel
      .subscribe(
        data => {
          this.transactionHistoryRequestModel = data;
          console.log("this.transactionHistoryRequestModel " + this.transactionHistoryRequestModel.FunctionID);
        },
        err => {
          this.router.navigate(['/transactions-error'])
            .then(() => {
              this.transactionsService.notifyTransactionsError.emit(err.message);
            }
            );
        }
      );


  }

  ngOnInit() {
    this.currentPageWatcherService.pageChanged().emit(this.title);

  }

//   setDate(): void {
//     // Set today date using the patchValue function
//     let date = new Date();
//     this.myForm.patchValue({startDate: {
//     date: {
//         year: date.getFullYear(),
//         month: date.getMonth() + 1,
//         day: date.getDate()}
//     }});
// }
  onContinueSubmit(startD, endD) {
    console.log(this.myForm);
    console.log(startD);
    this.currentPageWatcher.clearUserMessage();

    if (this.myForm.valid  && (this.myForm.value.startDate.epoc <= this.myForm.value.endDate.epoc)) {
      this.transactionHistoryRequestModel.StartDate = this.myForm.value.startDate.jsdate;
      this.transactionHistoryRequestModel.EndDate = this.myForm.value.endDate.jsdate;
      this.spinner.show();
      this.loading = true;
      //update transactionHistoryRequestModel in transactionsService to share it with result componenet (transaction-history-individual.component)
      this.transactionsService.transactionHistoryRequestModel = this.transactionHistoryRequestModel;
      //navigate to transaction-history-individual.component
      this.router.navigate(['/transactionIndividualHistory']);
    }

    else {
      if (startD.invalidDate) {
        let userMessage: MessageModel = {};
        userMessage.Alert = 3;
        userMessage.Description = "Start Date is invalid or not in the mm/dd/yyyy date format.";
        this.userMessages.push(userMessage);
        $("html, body").animate({ scrollTop: 0 }, "slow");
       
      }

      if (endD.invalidDate) {
        let userMessage: MessageModel = {};
        userMessage.Alert = 3;
        userMessage.Description = "End Date is invalid or not in the mm/dd/yyyy date format.";
        this.userMessages.push(userMessage);
        $("html, body").animate({ scrollTop: 0 }, "slow");
        
      }
       if ((this.myForm.controls.startDate.errors && this.myForm.controls.startDate.errors.required && !startD.invalidDate) || (this.myForm.value.startDate == null && !startD.invalidDate) ) {

          let userMessage: MessageModel = {};
          userMessage.Alert = 3;
          userMessage.Description = "Start Date is required.";
          this.userMessages.push(userMessage);
          $("html, body").animate({ scrollTop: 0 }, "slow");
         
        }

        if ((this.myForm.controls.endDate.errors && this.myForm.controls.endDate.errors.required && !endD.invalidDate) || (this.myForm.value.endDate == null && !endD.invalidDate)) {

          let userMessage: MessageModel = {};
          userMessage.Alert = 3;
          userMessage.Description = "End Date is required.";
          this.userMessages.push(userMessage);
          $("html, body").animate({ scrollTop: 0 }, "slow");
        
        }

        if (this.myForm.value.startDate!=null && this.myForm.value.endDate!=null && this.myForm.value.startDate.epoc > this.myForm.value.endDate.epoc) {

          let userMessage: MessageModel = {};
          userMessage.Alert = 3;
          userMessage.Description = "Start Date must be the same or earlier than End Date";
          this.userMessages.push(userMessage);
          $("html, body").animate({ scrollTop: 0 }, "slow");
        
        }
      this.currentPageWatcher.sendUserMessages(this.userMessages);
      this.userMessages = [];
    }

  }

  onDateChanged(event: IMyDateModel) {
    // event properties are: event.date, event.jsdate, event.formatted and event.epoc
    console.log('onDateChanged(): ', event.date, ' - jsdate: ', new Date(event.jsdate).toLocaleDateString(), ' - formatted: ', event.formatted, ' - epoc timestamp: ', event.epoc);
  }
  goBackHome() {
    this.router.navigate(['/home']);
  }

  ngOnDestroy(): void {
    this.currentPageWatcherService.clearUserMessage();
    this.currentPageWatcherService.clearStepMessage();
  }
}
export class TransactionHistoryModel {

  /**
   * Name of the Individual or Entity license
   */
  Name?: string;
  /**
   * License Number of the Individual or Entity license
   */
  LicenseNumber?: string;
  /**
  * Description of the action
  */
  ActionType?: string;
  /**
   * Date the transaction was submitted
   */
  DateSubmitted?: Date;
  /**
   * Date the transaction was due
   */
  DateDue?: Date;
  DateProcessed?: Date;
  /**
     * Description of the result of the approval process
     */
  Result?: string;
}


// WEBPACK FOOTER //
// ./src/app/transactions/transaction-history-individual-search/transaction-history-individual-search.component.ts